<template>
    <div>
        <empty-box class="query-form">
            <a-form-model :model="searchForm" layout="inline" ref="searchForm">
                <a-form-model-item label="订单编号" prop="orderId">
                    <a-input
                        v-model="searchForm.orderId"
                        placeholder="请输入订单编号"
                        allowClear
                    />
                </a-form-model-item>
                <a-form-model-item label="申请发票状态" prop="invoiceStatus">
                    <a-select
                        v-model="searchForm.invoiceStatus"
                        placeholder="请选择"
                        class="w140"
                        @change="handleQuery"
                    >
                        <a-select-option value="2">申请中</a-select-option>
                        <a-select-option value="3">可下载</a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item>
                    <a-button type="primary" @click="handleQuery"
                        >查询</a-button
                    >
                </a-form-model-item>
                <a-form-model-item>
                    <a-button @click="resetForm">重置</a-button>
                </a-form-model-item>
            </a-form-model>
        </empty-box>

        <a-table
            :columns="columns"
            :data-source="list"
            bordered
            :pagination="false"
            :rowKey="(record) => record.id"
            class="table-list"
        >
            <span slot="createTime" slot-scope="text">{{moment(text).format("YYYY-MM-DD HH:mm:ss")}}</span>
            <span slot="titleType" slot-scope="text">{{ titleTypeList[text] }}</span>
            <span slot="invoiceAmount" slot-scope="text">{{ text/100 }}</span>
            <template slot="status" slot-scope="text">
                <a-tag color="orange" v-if="text == 2">审核中</a-tag>
                <a-tag color="green" v-if="text == 3">已开票</a-tag>
            </template>
            <span slot="action" slot-scope="record">
                <a-button type="link" @click="handleDetail(record)">详情</a-button>
                <a-button type="link" @click="hanldeUpload(record)" v-if="record.status == 2">上传发票</a-button>
                <a-button type="link" @click="handleDownload(record)" v-if="record.status == 3">下载</a-button>
            </span>
        </a-table>

        <a-modal
            v-model="visible"
            title="发票详情"
            width="1000px"
            :footer="null"
        >
            <div>
                <h3 class="subtitle">发票基本信息</h3>
                <a-form layout="horizontal" class="info" :label-col=" { span: 2 }" :wrapper-col="wrapperCol">
                    <a-form-item label="发票状态">
                        <a-tag color="orange" v-if="detail.status == 2">审核中</a-tag>
                        <a-tag color="green" v-if="detail.status == 3">已开票</a-tag>
                    </a-form-item>
                    <a-form-item label="发票类型">
                        <span>{{ detail.invoiceType == 0 ? '普通发票' : '专用发票' }}</span>
                    </a-form-item>
                    <a-form-item label="抬头类型">
                        <span>{{ titleTypeList[detail.titleType] }}</span>
                    </a-form-item>
                    <a-form-item label="发票抬头">
                        <span>{{ detail.invoiceTitle }}</span>
                    </a-form-item>
                    <a-form-item label="申请时间">
                        <span>{{moment(detail.createTime).format("YYYY-MM-DD HH:mm:ss")}}</span>
                    </a-form-item>
                    <a-form-item label="发票编号">
                        <span>{{ detail.invoiceNo }}</span>
                    </a-form-item>
                </a-form>
            </div>
            <div>
                <h3 class="subtitle">订单信息</h3>
                <a-table
                    :columns="detailColumns"
                    :data-source="detail.orderList"
                    :pagination="false"
                    :rowKey="(record) => record.orderId"
                    class="table-list"
                >
                    <div slot="expandedRowRender" slot-scope="record" style="margin: 0">
                        <a-table :columns="orderColumns" :data-source="record.orderDetails" :pagination="false" class="table-list">
                            <span slot="totalAmount" slot-scope="text">{{ text/100 }}</span>
                            <span slot="orderAmount" slot-scope="text">{{ text/100 }}</span>
                        </a-table>
                    </div>
                    <span slot="orderAmount" slot-scope="text">{{ text/100 }}</span>
                    <span slot="payTime" slot-scope="text">{{moment(text).format("YYYY-MM-DD HH:mm:ss")}}</span>
                </a-table>
            </div>
        </a-modal>

        <a-modal 
            v-model="uploadFormVisible"
            title="上传发票"
            @ok="handleOk"
            @cancel="uploadFormVisible = false"
            width="800px">
            <a-form-model
                ref="ruleForm"
                :model="form"
                :rules="rules"
                :label-col="labelCol"
                :wrapper-col="wrapperCol"
                class="invoice-form"
            >
                <a-form-model-item label="发票编号" prop="invoiceNo">
                    <a-input v-model="form.invoiceNo" class="w240" />
                </a-form-model-item>
                <a-form-model-item label="发票" prop="invoiceUrl">
                    <a-upload
                        name="file"
                        :show-upload-list="false"
                        accept='.pdf,.png,.jpg'
                        action="/api/invoice/file/upload"
                        :headers="{
                            'Access-Cookie': $store.state.token,
                        }"
                        :before-upload="beforeUpload"
                        @change="handleChange"
                    >
                        <a-button> <a-icon type="upload" />点击上传</a-button>
                    </a-upload>
                    <div>文件大小不超过10兆</div>
                    <iframe v-if="form.invoiceUrl" :src="form.invoiceUrl" width="100%" height="400"></iframe>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>

<script>
import { queryApplyInvoiceList, dealInvoice } from "@/api/api";
import moment from "moment";
const columns = [
    {
        title: "申请时间",
        dataIndex: "createTime",
        key: "createTime",
        align: "center",
        scopedSlots: { customRender: "createTime" },
    },
    {
        title: "开票方",
        dataIndex: "drawer",
        key: "drawer",
        align: "center",
    },
    {
        title: "发票抬头",
        dataIndex: "invoiceTitle",
        key: "invoiceTitle",
        align: "center",
    },
    {
        title: "发票总额(元)",
        dataIndex: "invoiceAmount",
        key: "invoiceAmount",
        align: "center",
        scopedSlots: { customRender: "invoiceAmount" },
    },
    {
        title: "发票状态",
        dataIndex: "status",
        key: "status",
        align: "center",
        scopedSlots: { customRender: "status" },
    },
    {
        title: "操作",
        key: "action",
        align: "center",
        width: 190,
        scopedSlots: { customRender: "action" },
    },
];

const detailColumns = [
    {
        title: "订单号",
        dataIndex: "orderId",
        key: "orderId",
        align: "center",
    },
    {
        title: "订单支付时间",
        dataIndex: "payTime",
        key: "payTime",
        align: "center",
        scopedSlots: { customRender: 'payTime' },
    },
    {
        title: "金额(元)",
        dataIndex: "orderAmount",
        key: "orderAmount",
        align: "center",
        scopedSlots: { customRender: 'orderAmount' },
    },
];

const orderColumns = [
  {
    title: '设备编号',
    dataIndex: 'deviceNo',
    key: 'deviceNo',
    align: 'center'
  },
  {
    title: '设备型号',
    dataIndex: 'deviceModel',
    key: 'deviceModel',
    align: 'center'
  },
  {
    title: '总金额(元)',
    dataIndex: 'totalAmount',
    key: 'totalAmount',
    align: 'center',
    scopedSlots: { customRender: 'totalAmount' },
  },
  {
    title: '订单优惠后金额(元)',
    dataIndex: 'orderAmount',
    key: 'orderAmount',
    align: 'center',
    scopedSlots: { customRender: 'orderAmount' },
  },
  {
    title: '优惠明细',
    dataIndex: 'reduceDetail',
    key: 'reduceDetail',
    align: 'center'
  },
]

const titleTypeList = ["个人", "企业", "事业单位"];

export default {
    data() {
        let validateUrl = (rule, value, callback) => {
            if (!this.form.invoiceUrl) {
                callback(new Error('请上传发票'));
            } else {
                callback();
            }
        };
        return {
            moment,
            searchForm: {
                orderId: "",
                invoiceStatus: undefined,
            },
            columns,
            list: [],
            visible: false,
            detail: {},

            uploadFormVisible: false,
            labelCol: { span: 4 },
            wrapperCol: { span: 20 },
            detailColumns,
            rules: {},
            loading: false,
            titleTypeList,
            innerData: [],
            orderColumns,
            form: {
                invoiceNo: '',
                invoiceUrl: ''
            },
            fileUrl: '',
            rules: {
               invoiceNo: [{required: true, message: '请输入发票编号', trigger: 'blur'}],
               invoiceUrl: [{required: true, validator: validateUrl, trigger: 'change'}]
            },
        };
    },

    methods: {
        handleQuery() {
            this.getList()
        },

        resetForm() {
            this.$refs["searchForm"].resetFields();
            this.getList()
        },

        getList() {
            const para = {
                orderId: this.searchForm.orderId,
                invoiceStatus: this.searchForm.invoiceStatus,
            };
            queryApplyInvoiceList(para).then(({ error, response }) => {
                this.list = response.dataList;
            });
        },

        handleInvoice() {},

        // 查看详情
        handleDetail(row) {
            this.detail = Object.assign({}, row);

            this.detail.orderList.forEach(item => {
                item.orderDetails = item.orderDetails.map(vitem => {
                    return {
                        ...vitem,
                        ...vitem.priceInfo
                    }
                })
            });

            this.$nextTick(() => {
                this.visible = true;
            });
        },

        // 上传发票
        hanldeUpload(row) {
            this.detail = Object.assign({}, row);

            this.form = {
                invoiceNo: '',
                invoiceUrl: ''
            }
            this.fileUrl = ''

            this.uploadFormVisible = true

            this.$nextTick(() => {
                this.$refs['ruleForm'].resetFields()
            })
        },

        // 上传之前
        beforeUpload(file) {
            const canUpload = ['application/pdf'].includes(file.type)

            if (!canUpload) {
                this.$message.error('只支持上传pdf文件');
            }

            const isLt10M = file.size / 1024 / 1024 < 10;
            if (!isLt10M) {
                this.$message.error('文件大小必须小于10兆');
            }

            return canUpload && isLt10M
        },

        // 上传状态
        handleChange(info) {

            if (info.file.status === 'uploading') {
                this.loading = true;
                return;
            }
            if (info.file.status === 'done') {
                this.form.invoiceUrl = window.location.origin + info.file.response.response.fileUrl
                this.fileUrl = info.file.response.response.fileUrl
                this.loading = false;
            }
        },

        handleOk() {
            this.$refs['ruleForm'].validate(valid => {
                if (valid) {
                    const para = {
                        applyInvoiceId: this.detail.id,
                        invoiceNo: this.form.invoiceNo,
                        invoiceUrl: this.fileUrl
                    }
                    dealInvoice(para).then(({error, response}) => {
                        this.uploadFormVisible = false
                        this.getList()
                    })
                } else {
                    return false;
                }
            });
        },

        // 下载发票
        handleDownload(row) {
            // let url = 'http://192.168.0.60:2222/'+row.invoiceUrl

            let url = row.invoiceUrl

            const elink = document.createElement('a')

            elink.href = url

            elink.setAttribute('target', '_blank')

            elink.style.display = 'none'

            document.body.appendChild(elink)

            setTimeout(() => {

                elink.click()

                document.body.removeChild(elink)

            }, 66)
        }
    },

    created() {
        this.getList();
    },
};
</script>

<style lang="less" scoped>
/deep/ .info .ant-form-item {
    margin-bottom: 0;
}
</style>